import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const NEW_CONSTRUCTION_CATEGORIES: SupportCategory[] = [
  { id: 'newconstr-location', label: 'Location', departmentId: 'New Construction' },
  { id: 'newconstr-contacted', label: 'Contacted Builder', departmentId: 'New Construction' },
];

export const NEW_CONSTRUCTION_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'newconstr-location-sub', label: 'Location', categoryId: 'newconstr-location' },
  { id: 'newconstr-contacted-sub', label: 'Contacted Builder', categoryId: 'newconstr-contacted' },
];

export const NEW_CONSTRUCTION_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'newconstr-location-1',
    subcategoryId: 'newconstr-location-sub',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'newconstr-location-2',
    subcategoryId: 'newconstr-location-sub',
    type: 'text',
    label: 'Location',
    required: true,
  },
  {
    id: 'newconstr-contacted-1',
    subcategoryId: 'newconstr-contacted-sub',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'newconstr-contacted-2',
    subcategoryId: 'newconstr-contacted-sub',
    type: 'select',
    label: 'Contacted Builder',
    required: true,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' },
    ],
  },
];
